import React from 'react';
import styled from 'styled-components';
import moment from 'moment-timezone'; 

import { Button } from 'components'
import { FaArrowRight } from 'react-icons/fa'

const defaultStyle = {
    backgroundColor: 'var(--secondary-color)',
    subtitleColor: 'var(--secondary-accent-color)',
    titleColor: 'var(--text-color)',
    secondaryColor: 'var(--primary-color)',
    padding: '1rem 1.5rem',
    margin: '0.5rem 0',
    gridTemplateColumns: 'auto 1fr auto auto'
}

const iconStyle = {
    width:'2rem', 
    height:'2rem',
    objectFit:'contain', 
}

const Container = styled.div`
    background-color: ${props => props.styles.backgroundColor};
    border-radius: 5px;
    box-shadow: var(--box-shadow);
    padding: ${props => props.styles.padding};
    margin: ${props => props.styles.margin};
    display: flex;
    flex-direction: column;
    cursor: pointer;
    overflow: hidden;
    :hover{
        filter: brightness(var(--brightness));
    }
`

const MainContainer = styled.div`
    display: grid;
    grid-template-columns: ${props => props.styles.gridTemplateColumns};
    align-items: center;
`

const Icon = styled.div`
    border-radius: 5px;
    /* padding: 0.5rem; */
    display: flex;
    justify-content: center;
    align-items: center;
    height: inherit;
`

const Title = styled.div`
    font-weight: bold;
    color: ${props => props.styles.titleColor};
`

const Subtitle = styled.div`
    font-size: 0.8rem;
    color: ${props => props.styles.subtitleColor};
`

const Wrapper = styled.div`
    width: 100%;
    display: flex;
    flex-direction: column;
    margin: 0 0 0 1rem;
`

const IconContainer = styled.div`
    display: flex;
    align-items: center;
`

const WorkflowTile = props => {
    const {
        styles,
        title,
        subtitle,
        workflow,
        triggerIcon,
        actionIcon,
        onSelect
    } = props;
    const updatedStyles = Object.assign({}, defaultStyle, styles)
    const optionStyle = {
        backgroundColor: updatedStyles['secondaryColor'],
        margin: '0 0.5rem 0 0'
    }

    return (
        <Container styles={updatedStyles} onClick={onSelect}>
            <MainContainer styles={updatedStyles}>
                <Icon><img src={triggerIcon['value']} style={iconStyle}/></Icon>
                {/* <IconContainer>
                    <Icon><img src={triggerIcon['value']} style={iconStyle}/></Icon>
                    <FaArrowRight style={{fontSize: '1rem', margin: '0.5rem', color: 'var(--primary-accent-color)'}}/>
                    <Icon><img src={actionIcon['value']} style={iconStyle}/></Icon>
                </IconContainer> */}
                <Wrapper>
                    <Title styles={updatedStyles}>{title}</Title>
                    <Subtitle styles={updatedStyles}>{subtitle}</Subtitle>
                </Wrapper>
                {/* <Button text='Try it' styles={optionStyle}/> */}
            </MainContainer>
        </Container>
    )
}

export default WorkflowTile;